import type { NextPage } from 'next';

import { Box, Container } from '@chakra-ui/react';

import { FooterNav } from '~/components/footer-nav';
import { PageLayout } from '~/components/page-layout';
import { Seo } from '~/components/seo';
import { SignUpForm } from '~/features/sign-up';

const SignUp: NextPage = () => {
  return (
    <PageLayout>
      <Seo title='Sign up for Joyline.io' />
      <Container maxW='4xl' py={{ base: 4, lg: 16 }}>
        <SignUpForm />
        <Box h={8} />
        <FooterNav colorScheme='medium-gray' />
      </Container>
    </PageLayout>
  );
};

export default SignUp;
